// @flow
import api from 'app/core/api/api.js'
import type { StoreResourceDef } from 'app/core/types'
import type { GroupUsersActions } from 'app/core/types/StoreResourcesCustomActions'
import { transformResults } from './utils/transformResults'

export const groupUsers: StoreResourceDef<GroupUsersActions<>> = {
  resourceType: 'groupUsers',
  actions: (getResources: Object) => ({
    fetchAllByGroup: (groupId, config) => {
      const { params = {} } = config || {}
      return {
        type: 'read',
        requestKey: config?.requestKey,
        request: () => api.groups.users({ id: groupId }, params.queries).then(transformResults({ ...config })),
      }
    },
    fetchSearchUserByGroup: (data, config = {}) => {
      const { requestKey, params = {}, ...restConfig } = config || {}
      const { groupId } = data
      const fetchUsers = (page, groupUsers = { results: [] }) => {
        return api.groups
          .users(
            { id: groupId },
            { ...params.queries, page, page_size: 200 },
            params.headers,
            params.getHttpProgress,
            params.requestController,
          )
          .then((res) => {
            const results = {
              ...res,
              results: groupUsers?.results.concat(res?.results?.assetsInst) || [],
            }
            if (res?.next) return fetchUsers(page + 1, results)
            return results
          })
      }
      return {
        type: 'read',
        requestKey,
        request: () => fetchUsers(1).then(transformResults(restConfig)),
      }
    },
  }),
  relations: {
    userInst: {
      type: 'hasOne',
      resourceType: 'assets',
      foreignKey: 'user',
    },
    groupInst: {
      type: 'hasOne',
      resourceType: 'groups',
      foreignKey: 'group',
    },
  },
}
